module.exports = __webpack_public_path__ + "media/promo/panasonic/images/artm-a8ec757c16f782304f59c592a4307346.jpg";